export default __webpack_public_path__ + "static/e-commerce-real-estate-76cfaf40b35d499d11f5ba209b8dfe7b.svg";